import * as _ from 'lodash';
import { Observable, Observer } from 'rxjs';
import ARHttp from './ARHttp';
import { PaymentInsiderParams } from '../models/PaymentInsiderParams';
import { GetJurisdictionRegionResponseModel } from '../models/GetJurisdictionRegionResponseModel';

function redirectToPaymentInsider(paymentInsiderParams: PaymentInsiderParams): Observable<boolean> {
  return new Observable((observer: Observer<boolean>) => {
    getJurisdictionRegion(paymentInsiderParams.jurisdictionCode, paymentInsiderParams.subJurisdictionCode)
      .subscribe((regionResponse: GetJurisdictionRegionResponseModel) => {
        if (regionResponse.region === 'NA') {
          getProperties(paymentInsiderParams.locale).subscribe((response: any) => {
            if (response && response.stringProps) {
              const stringProperties: string[] = response.stringProps.split('\n');
              const redirectProperty = _.find(stringProperties, (property: string) => property.split('=')[0] === 'CIAM_REDIRECT_NA_URL');
              if (redirectProperty) {
                observer.next(true);
                const url: string = buildUrl(redirectProperty.split('=')[1], paymentInsiderParams);
                window.location.assign(url);
              } else {
                observer.next(false);
              }
            } else {
              observer.next(false);
            }
          }, () => observer.next(false));
        } else {
          observer.next(false);
        }
      }, () => observer.next(false));
  });
}

function buildUrl(stringPropUrl: string, paymentInsiderParams: PaymentInsiderParams): string {
  let stringParams = '';
  if (!_.isEmpty(paymentInsiderParams.jurisdictionCode)) {
    stringParams = `${urlBuilderHelper(stringParams)}jc=${paymentInsiderParams.jurisdictionCode}`;
  }
  if (!_.isEmpty(paymentInsiderParams.subJurisdictionCode)) {
    stringParams = `${urlBuilderHelper(stringParams)}sj=${paymentInsiderParams.subJurisdictionCode}`;
  }
  if (!_.isEmpty(paymentInsiderParams.offering)) {
    stringParams = `${urlBuilderHelper(stringParams)}offering=${paymentInsiderParams.offering}`;
  }
  if (!_.isEmpty(paymentInsiderParams.locale)) {
    stringParams = `${urlBuilderHelper(stringParams)}locale=${paymentInsiderParams.locale}`;
  }
  return stringPropUrl + buildUrlPath(paymentInsiderParams.locale) + stringParams;
}

function buildUrlPath(locale: string): string {
  const language = (locale) ? locale.substring(0, 2) : '';
  return `/ui/#/${language}/selfboard/connect`;
}

function urlBuilderHelper(paramsString: string): string {
  if (_.isEmpty(paramsString)) {
    return '?';
  }
  return `${paramsString}&`;
}

function getProperties(locale: string): Observable<any> {
  const language = (locale) ? locale.substring(0, 2) : '';
  return ARHttp({
    method: 'POST',
    url: '/sb/buildStringProps',
    body: {
      stringPropParams: {
        applicationType: 'SELFBOARD',
        language,
        subJurisdictionCode: '',
      },
    },
  });
}

function getJurisdictionRegion(jurisdictionCode: string, subJurisdictionCode: string): Observable<any> {
  return ARHttp({
    method: 'POST',
    url: '/sb/getJurisdictionRegion',
    body: {
      jurisdictionCode,
      subJurisdictionCode,
    },
  });
}

export default {
  redirectToPaymentInsider,
  getProperties,
  getJurisdictionRegion,
  buildUrl,
};
